import { useMemo } from 'react';
import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '../';
import { orderAnswers } from 'npo/pages/BetaFeedback/AnswersProvider';

export const answersQuery = gql`
  query reportAnswers($id: ID) {
    allReports(filters: { id: $id }) {
      edges {
        node {
          stage
          status
          answers {
            edges {
              node {
                dbId
                text
                questionId
                date1
                date2
                autoAnswered
                resourceId
                question {
                  dbId
                  text
                  section
                  questionType
                  nextQuestionId
                  enumResponses {
                    edges {
                      node {
                        dbId
                        order
                        responseType
                        response
                        responseValue
                        responseHelp
                        questionId
                        nextQuestionId
                        treeGroup
                      }
                    }
                  }
                }
                enumResponse {
                  dbId
                  response
                  responseType
                  nextQuestionId
                  treeGroup
                }
                answerValidations {
                  edges {
                    node {
                      validationId
                      hidden
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const useReportAnswers = reportId => {
  if (!reportId || reportId === 'new') {
    return { data: [], refetch: () => { /* noop */ }, loading: false };
  }
  // const { data: rawData, refetch, loading } = useQuery(query, { variables: { id: reportId }, fetchPolicy: "network-only",
  // notifyOnNetworkStatusChange: true, })
  const { data: rawData, refetch, loading } = useQuery(answersQuery, {
    variables: { id: reportId },
    fetchPolicy: 'no-cache',
  });
  const removedConnections = removeConnectionsMemoized(rawData?.allReports);
  const data =
    rawData?.allReports?.edges.length > 0
      ? removedConnections[0]?.answers ?? []
      : [];
  const orderedData = useMemo(() => orderAnswers(data), [data]);
  return {
    data: orderedData,
    refetch,
    loading,
    reportStatus: removedConnections?.[0]?.status || 'Draft',
  };
};
